import Env from './Env.json';
import Env_stage from './Env_stage.json';
import Env_prod from './Env_prod.json';

export let PROFILE = process.env.VUE_APP_MODE;
export let CODE_ENV_LIST = Env;
if (process.env.NODE_ENV === 'production') {
  PROFILE = 'prod';
  CODE_ENV_LIST = Env_prod;
} else if (process.env.VUE_APP_MODE === 'stage') {
  PROFILE = 'test';
  CODE_ENV_LIST = Env_stage;
}
/**
 *  <h3> navigationItem icons </h3>
 *  <br/>
 * [Search Icons!](https://fontawesome.com/icons/)
 * <br/>
 * size :
 * ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']
 */

export * from '@/common/constants/Enumerations';
export const NAVIGATION_ITEM = [
  {
    title: '회원 관리',
    icon: {
      name: ['fas', 'user'],
      color: 'black'
    },
    color: '',
    inner: [
      {
        title: '회원 신청',
        to: '/user/apply',
        active: '회원 관리'
      },
      {
        title: '회원 정보',
        to: '/user',
        active: '회원 관리'
      },
      {
        title: '기기 초기화 신청 내역',
        to: '/user/reset-device-list',
        active: '회원 관리'
      },
      {
        title: '번호 초기화 신청 내역',
        to: '/user/reset-phone-list',
        active: '회원 관리'
      }
    ]
  },
  {
    title: '이력 관리',
    icon: {
      name: ['fas', 'calendar-day'],
      size: 'lg'
    },
    inner: [
      {
        title: '전화번호 이력 관리',
        to: '/history/phone',
        active: '이력 관리'
      },
      {
        title: '민원 처리내역 관리',
        to: '/history/complaint',
        active: '이력 관리'
      }
    ]
  },
  {
    title: '상품 관리',
    icon: {
      name: ['fas', 'ticket'],
      size: 'lg'
    },
    inner: [
      {
        title: '상품 신청 내역',
        to: '/product/apply',
        active: '상품 관리'
      },
      {
        title: '이용권 관리',
        to: '/product',
        active: '상품 관리'
      }
    ]
  },
  {
    title: '운영 관리',
    icon: {
      name: ['fas', 'note-sticky'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '공지사항 관리',
        to: '/operate/board',
        active: '운영 관리'
      },
      {
        title: '1:1 문의 관리',
        to: '/operate/inquiry/user',
        active: '운영 관리'
      },
      {
        title: '비회원 1:1 문의 관리',
        to: '/operate/inquiry/non-user',
        active: '운영 관리'
      },
      {
        title: '광고 배너 관리',
        to: '/operate/banner',
        active: '운영 관리'
      },
      {
        title: '즐겨찾기 관리',
        to: '/operate/menu',
        active: '운영 관리'
      },
      {
        title: '광고 푸시 관리',
        to: '/operate/push',
        active: '운영 관리'
      }
    ]
  }
];
export const LOGIN_TOKEN_NAME = 'Authorization';
export const BOARD_TYPE = {
  NOTICE: { value: 'NOTICE', label: '공지사항' },
  FAQ: { value: 'FAQ', label: '자주묻는질문' }
};

export const MAIN_COLOR = '#0000ED';
export const MAIN_PATH = '/user/apply';
export const SESSION_TIME_OUT = {
  INFINITE: 0,
  nHour: (hour = 1) => {
    const result = hour * 60 * 60 * 1000;
    if (isNaN(result)) return 1 * 60 * 60 * 1000;
    else return result;
  },
  nDay: (day = 1) => {
    const result = day * 24 * 60 * 60 * 1000;
    if (isNaN(result)) return 1 * 24 * 60 * 60 * 1000;
    else return result;
  },
  nMin: (min = 1) => {
    const result = min * 60 * 1000;
    if (isNaN(result)) return 1 * 60 * 1000;
    else return result;
  }
};

export default {
  CODE_ENV_LIST,
  LOGIN_TOKEN_NAME,
  NAVIGATION_ITEM,
  BOARD_TYPE,
  MAIN_PATH,
  MAIN_COLOR
};
